Ply.AllocationWizard = function(el) {
    console.log("initializing");
    this.dom = {
        el: el,
        switchee: el.querySelector("[data-allocation-switchee]"),
        selectionContainer: el.querySelector("[data-allocation-step='allocation']"),
        wishlistContainer: el.querySelector("[data-allocation-step='wishlist']"),
        switcher: document.createElement('ul'),
        wishlistCheckbox: el.querySelector(".wishlist-checkbox")
    };

    var options;
    try {
        options = JSON.parse(el.dataset.allocationWizard);
    } catch (e) {
        options = {};
        console.log(e);
    }
    if (!!options.discountCode) {
        bloom.setDiscountCode(options.discountCode)
    }

    this.state = {
        products: [],
        selectedProductHandle: null,
        enableWishlist: false,
        wishlistItems: [],
        target: 'bloomCheckout',
        productVariantId: null
    };

    this.handleSelectButtonClick = this.handleSelectButtonClick.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    this.handleWishlistQuantityChange = this.handleWishlistQuantityChange.bind(this);
    this.handleSkipButtonClick = this.handleSkipButtonClick.bind(this);
    this.handleCheckoutButtonClick = this.handleCheckoutButtonClick.bind(this);
    this.saveCheckoutId = this.saveCheckoutId.bind(this);
    this.fetchProducts = this.fetchProducts.bind(this);
    this.render = this.render.bind(this);
    this.clearWishlist = this.clearWishlist.bind(this);
    this.saveWishlist = this.saveWishlist.bind(this);
    this.updateWishlistItems = this.updateWishlistItems.bind(this);
    this.redirectToCheckout = this.redirectToCheckout.bind(this);
    this.initProductDetails = this.initProductDetails.bind(this);

    this.selectionStep = new Ply.AllocationWizardSelectionStep(this.dom.selectionContainer, {
        props: this.state,
        onSelectButtonClick: this.handleSelectButtonClick
    });

    this.wishlistStep = new Ply.AllocationWizardWishlistStep(this.dom.wishlistContainer, {
        props: this.state,
        onBackButtonClick: this.handleBackButtonClick,
        onSkipButtonClick: this.handleSkipButtonClick,
        onCheckoutButtonClick: this.handleCheckoutButtonClick,
        onQuantityChange: this.handleWishlistQuantityChange
    });

    this.productTitles = Ply.makeArray(this.dom.el.querySelectorAll("[data-product]")).map(this.initProductDetails);

    this.initializeSwitcher();

    this.client = ShopifyBuy.buildClient({
        domain: 'bloomdemo.myshopify.com',
        storefrontAccessToken: '389f89b86fe6a3fbc3ad4941974fc962'
    });

    this.storage = window.localStorage;

    this.getCheckout()
        .then(this.saveCheckoutId)
        .then(this.fetchProducts)
        .then(this.render);
};

Ply.AllocationWizard.prototype.render = function() {
    if (this.state.selectedProductHandle && this.state.enableWishlist) {
        this.wishlistStep.render();
        this.switcher.show(1);
    } else {
        this.selectionStep.render();
        this.switcher.show(0);
    }
};

Ply.AllocationWizard.prototype.initProductDetails = function(el) {
    return new Ply.AllocationWizardProductDetails(el, {
        props: this.state
    });
};

Ply.AllocationWizard.prototype.getCheckout = function() {
    if (this.storage.getItem("bloomCheckoutId")) {
        return this.client.checkout
            .fetch(this.storage.getItem("bloomCheckoutId"))
            .then(function(checkout) {
                return checkout.completedAt ? this.client.checkout.create() : checkout;
            }.bind(this))
            .catch(function(error) {
                console.log("An error occured when attempting to retrieve the checkout", error);
                return this.client.checkout.create();
            }.bind(this));
    } else {
        return this.client.checkout.create();
    }
};

Ply.AllocationWizard.prototype.saveCheckoutId = function(checkout) {
    this.storage.setItem("bloomCheckoutId", checkout.id);
};

Ply.AllocationWizard.prototype.fetchProducts = function() {
    return this.client.product.fetchAll().then(function(products) {
        this.state.products = products;
    }.bind(this));
};

Ply.AllocationWizard.prototype.handleSelectButtonClick = function(event) {
    var card = event.target.closest("[data-card-top]");
    var productSelections = card.querySelectorAll("select");
    var obj = {};
    var qty = 0;
    var selectionQuantity = productSelections.length > 0 ? productSelections.forEach(function(el){
        obj[el.getAttribute("data-variant-id")] = parseInt(el.value);
        qty += parseInt(el.value);
    }) : null;
    this.state.selectedProductHandle = event.target.dataset.allocationSelect;
    this.state.productVariantId = event.target.dataset.variantId;

    if (!selectionQuantity && !!this.state.productVariantId) {
        obj[this.state.productVariantId] = 1
    }

    var properties = {}
    var cartProperties = {}
    var hasAllocationName = document.querySelector("[data-allocation-name]") && !!(document.querySelector("[data-allocation-name]").dataset.allocationName);
    var allocationName = hasAllocationName ? document.querySelector("[data-allocation-name]").dataset.allocationName : null;
    var hasCheckedWishlistCheckbox = this.dom.wishlistCheckbox && this.dom.wishlistCheckbox.value === "on";
    if(allocationName) {
        properties["_Bloom allocation"] = allocationName;
        cartProperties["Bloom allocation"] = allocationName;
    }
    if(hasCheckedWishlistCheckbox) {
        cartProperties["Wishlist"] = "Yes"
    }

    switch (this.state.target) {
        case 'bloomCheckout':
            bloomCart.reset().then(function() {

                var items = Object.keys(obj).map(function(vId, idx) { return ({ id: parseInt(vId), quantity: obj[vId], properties: properties }) })

                debugger;
                bloomCart.add(items).then(bloomCart.get).then(function(cart) {
                    discountCode = Bloom.storefront.utilities._.getDiscountCodeForCart(cart);
                    if(!!discountCode) {
                        bloom.setDiscountCode(discountCode);
                    }
                    if(allocationName || hasCheckedWishlistCheckbox) {
                        bloomCart.update({attributes: cartProperties}).then(function(){
                            bloom.goToBloomCheckout({ return_link_url: window.location.pathname, return_link_label: 'Return to allocation' });
                        });
                    } else {
                        bloom.goToBloomCheckout({ return_link_url: window.location.pathname, return_link_label: 'Return to allocation' });
                    }
                });
            });
            break;
        case 'storefrontCheckout':
            this.updateLineItems();
            this.scrollToTop();
            this.render();
            !this.state.enableWishlist && this.handleSkipButtonClick();
            break;
        default:
            if(selectionQuantity && selectionQuantity > 0){
                for (var k in obj) {
                    if (p.hasOwnProperty(k)) {
                        Bloom.storefront.utilities.addToCart(k, obj[k]);
                    }
                }
            } else {
                Bloom.storefront.utilities.addToCart(this.state.productVariantId, 1);
            }
    }
};


Ply.AllocationWizard.prototype.scrollToTop = function(event) {
    this.scroller = UIkit.scroll(this.dom.el, { duration: 1000 });
    this.scroller.scrollTo("#allocation-top");
    this.scroller.$destroy();
};

Ply.AllocationWizard.prototype.updateLineItems = async function() {
    const checkout = await this.getCheckout();
    const lineItemIdsToRemove = checkout.lineItems.map(function(lineItem) { return lineItem.id });
    if (lineItemIdsToRemove.length > 0) {
        await this.client.checkout.removeLineItems(this.storage.getItem("bloomCheckoutId"), lineItemIdsToRemove);
    }
    await this.addSelectedVariantToCheckout();
};

Ply.AllocationWizard.prototype.addSelectedVariantToCheckout = function() {
    var lineItemsToAdd = [
        { variantId: this.getProductByHandle(this.state.selectedProductHandle).variants[0].id, quantity: 1 }
    ];
    this.client.checkout.addLineItems(this.storage.getItem("bloomCheckoutId"), lineItemsToAdd).then(function(checkout) {
        console.log("added", checkout.lineItems);
    });
};

Ply.AllocationWizard.prototype.addOrderNote = function(key, value) {
    this.client.checkout.updateAttributes(shop.checkoutId,
        {customAttributes: [{key: key, value: value}]}
    );
}

Ply.AllocationWizard.prototype.handleBackButtonClick = function(event) {
    this.state.selectedProductHandle = null;
    this.scrollToTop();
    this.render();
};

Ply.AllocationWizard.prototype.handleSkipButtonClick = function(event) {
    this.getCheckout().then(this.clearWishlist).then(this.redirectToCheckout);
};

Ply.AllocationWizard.prototype.handleCheckoutButtonClick = function(event) {
    this.getCheckout().then(this.saveWishlist).then(this.redirectToCheckout);
};

Ply.AllocationWizard.prototype.clearWishlist = function(checkout) {
    return this.updateWishlistItems(checkout, "");
};

Ply.AllocationWizard.prototype.saveWishlist = function(checkout) {
    return this.updateWishlistItems(checkout, this.wishlistItemsToCheckoutAttribute());
};

Ply.AllocationWizard.prototype.updateWishlistItems = function(checkout, wishlistItems) {
    var input = { customAttributes: [{ key: "Wishlist items", value: wishlistItems }] };
    return this.client.checkout.updateAttributes(checkout.id, input);
};

Ply.AllocationWizard.prototype.redirectToCheckout = function(checkout) {
    console.log("Redirecting to checkout...", this.state, checkout);
    setTimeout(function() {
        window.location.href = checkout.webUrl;
    }, 300);
};

Ply.AllocationWizard.prototype.handleWishlistQuantityChange = function(event) {
    this.setWishlistItem(event.target.dataset.wishlistInput, event.target.value);
    this.render();
};

Ply.AllocationWizard.prototype.getWishlistItemById = function(id) {
    return this.state.wishlistItems.find(Ply.byId(id));
};

Ply.AllocationWizard.prototype.getProductByHandle = function(handle) {
    return this.state.products.find(Ply.byProp("handle", handle));
};

Ply.AllocationWizard.prototype.setWishlistItem = function(id, quantity) {
    var wishlistItem = this.getWishlistItemById(id);
    if (wishlistItem) {
        wishlistItem.quantity = quantity;
    } else {
        this.state.wishlistItems.push({ id: id, quantity: quantity });
    }
};

Ply.AllocationWizard.prototype.wishlistItemsToCheckoutAttribute = function() {
    return this.state.wishlistItems
        .map(function(wishlistItem) {
            if (parseInt(wishlistItem.quantity) > 0) {
                return this.getProductByHandle(wishlistItem.id).title + " x" + wishlistItem.quantity;
            }
        }.bind(this))
        .join(", ");
};

Ply.AllocationWizard.prototype.initializeSwitcher = function() {
    Ply.addClass(this.dom.switchee, "uk-switcher");
    for (var i = 0; i < 2; i++) {
        this.dom.switcher.insertBefore(document.createElement("li"), this.dom.switcher.firstChild);
    }
    this.dom.el.insertBefore(this.dom.switcher, this.dom.el.firstChild);
    Ply.addClass(this.dom.switcher, "uk-hidden");
    this.switcher = UIkit.switcher(this.dom.switcher, { animation: "uk-animation-fade", duration: 1000 });
};
